module.exports = "https://web-assets.ifttt.com/packs/media/ifttt_next/business_banner_illustration-f49869e0.svg";